import R from 'ramda'
import { AC_STATUS_FILTERS } from '../../server/constants'

import {
  ACTIONS,
  METHODS,
  AUTH_API_URL
} from '../constants'

import * as page from './page'

export const getStatePath = institutionId => ['pages', institutionId]
export const activationCodesStatePath = institutionId => ['pages', institutionId, 'activationCodes']

const single = {
  type: ACTIONS.FETCH_INSTITUTION.START,
  actionSet: ACTIONS.FETCH_INSTITUTION
}
const getOne = R.merge(single, {method: METHODS.GET})
const deleteOne = R.merge(single, {method: METHODS.DELETE})
const postOne = R.merge(single, {method: METHODS.POST})

export const refresh = ({
  institutionId
}) => R.merge(getOne, {
  statePath: getStatePath(institutionId),
  url: `${AUTH_API_URL}/institutions/${institutionId}`,
  _id: institutionId
})

// Inst. Keys
export const removeKeyedSessionMachine = ({
  institutionId,
  keyId, // subscriptions, max7, max8 etc
  // source, // subscriptions, max7, max8 etc
  machineId
}) => R.merge(deleteOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/keys/${keyId}/machines/${machineId}`,
  statePath: getStatePath(institutionId),
  _id: institutionId
})

export const deactivateKey = ({
  institutionId,
  keyId
}) => R.merge(deleteOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/keys/${keyId}`,
  _id: institutionId,
  statePath: getStatePath(institutionId)
})

export const postKey = ({
  institutionId,
  payload = {}
}) => R.merge(postOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/keys`,
  _id: institutionId,
  statePath: getStatePath(institutionId),
  payload
})

// Inst. Activation Codes
export const activationCodesDeactivate = ({
  institutionId,
  licenseId
}) => R.merge(page.parts.deleteOne, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/activationcodes/${licenseId}`,
  // _id: licenseId,   // maybe it is better to NOT set the _id here and let the whole AC list show a loading
  statePath: activationCodesStatePath(institutionId)
})

export const activationCodesRefreshList = ({
  institutionId,
  pageNum = 1,
  perPage = 20,
  term = '',
  showExpired = false,
  status = AC_STATUS_FILTERS.ALL
}) => R.merge(page.parts.getList, {
  url: `${AUTH_API_URL}/institutions/${institutionId}/activationcodes`,
  statePath: activationCodesStatePath(institutionId),
  query: {pageNum, perPage, term, showExpired, status}
})

export const activationCodesFetchAcSuggestions = ({
  institutionId,
  term,
  pageNum
}) => ({
  type: ACTIONS.AUTOCOMPLETE.START,
  actionSet: ACTIONS.AUTOCOMPLETE,
  method: METHODS.GET,
  url: `${AUTH_API_URL}/institutions/${institutionId}/activationcodes`,
  // _id: institutionId,
  statePath: activationCodesStatePath(institutionId),
  query: {
    term,
    pageNum
  }
})

export const activationCodesSetAcSelections = ({
  institutionId,
  selections
}) => {
  const url = `${AUTH_API_URL}/institutions/${institutionId}/activationcodes`
  const statePath = activationCodesStatePath(institutionId)
  return {
    type: ACTIONS.AUTOCOMPLETE.SET_SELECTIONS,
    selections,
    url,
    statePath,
    onSuccessAction: {
      type: ACTIONS.FETCH_LIST.START,
      actionSet: ACTIONS.FETCH_LIST,
      url,
      statePath,
      query: {
        pageNum: 1,
        perPage: 20,
        ids: selections.map(s => s._id)
      }
    }
  }
}

export const activationCodesClearAcSelections = ({
  institutionId
}) => ({
  type: ACTIONS.AUTOCOMPLETE.CLEAR_SUGGESTIONS,
  url: `${AUTH_API_URL}/institutions/${institutionId}/activationcodes`,
  statePath: activationCodesStatePath(institutionId)
})



// WEBPACK FOOTER //
// ./webAdmin/actions/thirdParty.js